"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZSearchPopup = void 0;
const React = __importStar(require("react"));
const __1 = require("../");
const ll_1 = require("../../languages/ll");
const useResizeObserver_1 = require("../../utils/useResizeObserver");
const utils_1 = require("../../utils");
const styled_components_1 = __importDefault(require("styled-components"));
const defaultWidth = 900;
const defaultHeight = 800;
const minWidth = 725;
const minHeight = 560;
const ZSearchPopupComponent = (props) => {
    const { title, entity, resizable, visible, closeHandler, className, searchOptions: searchOptionsFromProps, id, endpoint, columns, oDataFilter, select, data, initialHeight, initialWidth, ...popupProps } = props;
    const [formState, setFormState] = React.useState({});
    const [selectedId, setSelectedId] = React.useState((data && data[0] && data[0].Id) || null);
    const { languageId } = React.useContext(ll_1.llContext);
    const fieldRefs = React.useRef([]);
    React.useEffect(() => {
        fieldRefs.current = fieldRefs.current.slice(0, searchOptionsFromProps ? searchOptionsFromProps.length : 0);
    }, [searchOptionsFromProps]);
    const searchOptions = React.useMemo(() => {
        if (searchOptionsFromProps) {
            return searchOptionsFromProps.map((so, i) => {
                return (React.createElement(__1.ZTextBox, { label: so.title || so.field, key: so.field, id: so.field, ref: el => (fieldRefs.current[i] = el) }));
            });
        }
        return null;
    }, [searchOptionsFromProps]);
    const gridRef = React.useRef(null);
    const { innerWidth, innerHeight } = utils_1.useViewport();
    const headerRef = React.useRef(null);
    const [headerHeight, setHeaderHeight] = React.useState(0);
    const popupRef = React.useRef(null);
    const popupElementRef = React.useRef(null);
    const [popupHeight, setPopupHeight] = React.useState(800);
    useResizeObserver_1.useResizeObserver(headerRef, dimensions => {
        setHeaderHeight(dimensions.height);
    });
    useResizeObserver_1.useResizeObserver(popupElementRef, dimensions => {
        setPopupHeight(dimensions.height);
    });
    const gridHeight = React.useMemo(() => popupHeight - 140 - headerHeight, [headerHeight, popupHeight]);
    const [windowRendered, setWindowRendered] = React.useState(false);
    const height = initialHeight || defaultHeight;
    const width = initialWidth || defaultWidth;
    return (React.createElement(__1.ZPopup, Object.assign({}, popupProps, { popupRef: window => {
            popupRef.current = window;
            popupElementRef.current = window && window.windowElement;
            if (window && windowRendered === false) {
                window.setState({
                    // top: (innerHeight - height) / 2,
                    // left: (innerWidth - width) / 2,
                    width: Math.min(innerWidth, width),
                    height: Math.min(innerHeight, height)
                }, () => setWindowRendered(true));
            }
        }, title: title ||
            ll_1.ll({ key: "EntitySearch", languageId }).format(ll_1.ll({ key: entity, languageId })), localize: false, minHeight: minHeight, minWidth: minWidth, initialWidth: width, initialHeight: height, resizable: resizable || true, allowMaximize: true, visible: visible, onClose: event => closeHandler && closeHandler(null, null) }),
        React.createElement(__1.AlertProvider, null,
            React.createElement("div", { className: className },
                searchOptionsFromProps ? (React.createElement("div", { className: "z-popup-header", ref: headerRef },
                    React.createElement("div", { className: "z-search-options" },
                        React.createElement(__1.ZForm, { onFormChange: (valid, values) => {
                                setFormState({ ...formState, fields: values });
                            }, render: (context) => (React.createElement(__1.ZContainer, { id: id }, searchOptions || [])) })),
                    React.createElement("div", null,
                        React.createElement(__1.ZButton, { className: "z-search-popup-clear-button", onClick: event => {
                                fieldRefs.current.forEach(f => {
                                    f.setValue("");
                                });
                            } }, "Clear")))) : null,
                React.createElement("div", null,
                    React.createElement(__1.ZGrid, { sortable: true, entity: entity, endpoint: endpoint, select: columns
                            .map(c => c.field || "")
                            .concat(select || []), data: data
                            ? data.map(d => d && d.Id === selectedId
                                ? { ...d, selected: true }
                                : { ...d, selected: false })
                            : undefined, oDataFilter: oDataFilter, onRowClick: event => setSelectedId(event.dataItem.Id), onDoubleClick: (event, row) => {
                            closeHandler &&
                                closeHandler({ target: { value: row.dataItem } }, row.dataItem);
                        }, columns: columns, style: {
                            width: "100%",
                            height: gridHeight
                        }, pageable: true, selectedField: "selected", filter: {
                            logic: "and",
                            filters: searchOptionsFromProps
                                ? searchOptionsFromProps.map(so => ({
                                    field: so.field,
                                    operator: "contains",
                                    value: formState &&
                                        formState.fields &&
                                        formState.fields[so.field]
                                        ? formState.fields[so.field].value
                                        : ""
                                }))
                                : []
                        }, setGridInstance: gridInstance => (gridRef.current = gridInstance) })),
                React.createElement("div", { className: "z-search-popup-action-buttons" },
                    React.createElement(__1.ZButton, { className: "z-search-popup-choose-button", onClick: event => {
                            if (closeHandler &&
                                typeof closeHandler === "function") {
                                const dataItem = gridRef.current &&
                                    ((gridRef.current.props.data &&
                                        gridRef.current.props.data
                                            .data) ||
                                        gridRef.current.props.data ||
                                        gridRef.current.state.dataResult
                                            .data).find(d => d.Id === selectedId);
                                closeHandler(null, dataItem);
                            }
                        }, primary: true }, ll_1.ll({ key: "Select", languageId })),
                    React.createElement(__1.ZButton, { className: "z-search-popup-cancel-button", onClick: event => {
                            closeHandler && closeHandler(null, null);
                        } }, "Cancel"))))));
};
exports.ZSearchPopup = styled_components_1.default(ZSearchPopupComponent) `
   display: inline-flex;
   flex-direction: column;
   & .z-search-popup-action-buttons {
      display: flex;
      flex-direction: row-reverse;
   }
   & .z-search-popup-choose-button {
      margin-top: 10px;
   }
   & .z-search-popup-cancel-button {
      margin-top: 10px;
   }
   & .k-ripple-container {
      align-self: center;
      margin-top: 5px;
   }
   & .z-popup-header {
      display: grid;
      width: 100%;
      grid-template-columns: 1fr 90px !important;
      align-items: center;
   }
   & .z-search-options {
      display: flex;
      flex-flow: wrap;
      justify-content: space-evenly;
      & .z-pane {
         width: 100%;
      }
   }
   .k-content.k-window-content {
      display: inline-flex !important;
   }
   .k-window {
      padding-bottom: 24px;
   }
`;
//# sourceMappingURL=ZSearchPopup.js.map